<style lang="scss">
.equipmentTabs {
  .el-tabs {
    flex: 1;

    .el-tabs__item {
      color: #c0c4cc;
    }

    .el-tabs__item.is-active {
      color: #419fff;
    }

    .el-tabs__item:hover {
      color: #419fff;
    }

    .el-tabs__active-bar.is-top {
      background: #419fff;
    }

    .el-tabs__active-bar {
      background: #606672;
    }

    .el-tabs__nav-wrap:after {
      background-color: #606672;
    }
  }
}
</style>
<style scoped="scoped" lang="scss">
.mytable {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
  //#606672
}
.mytable /deep/ table {
  border-collapse: collapse;
}
.mytable /deep/ table tbody tr:first-child {
  height: 42px;
  font-size: 12px;
}
.mytable /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t('tongjixinxi') }}
      </p>
    </div>
    <div class="equipmentTabs" :style="{ height: contentHeight + 'px' }">
      <el-tabs v-model="current" @tab-click="handleClick">
        <el-tab-pane v-for="(tab, index) in tabs" :label="$t(tab)" :name="tab">
          <component :is="tab" technology :style="{ height: tabHeight + 'px' }" :equipment="equipment" :tabsData="tabsData"></component>
        </el-tab-pane>
        <el-tab-pane v-for="(device, index) in tabsData.devices" :label="$t(device.device.name)" :name="$t(device.device.name)">
          <div class="mytable" v-html="gy(device.tab.gy, device.device.id, device.pointList)"></div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script type="text/javascript">
import gongyicanshu from '@@/pages/web/monitor/workshop_mes/equipment/statistics_tabs/technology';
import shengchantongji from '@@/pages/web/monitor/workshop_mes/equipment/statistics_tabs/produce';
import gongkuangcanshu from '@@/pages/web/monitor/workshop_mes/equipment/statistics_tabs/working_state';
import baojingxinxi from '@@/pages/web/monitor/workshop_mes/equipment/statistics_tabs/alert';
import jibenxinxi from '@@/pages/web/monitor/workshop_mes/equipment/statistics_tabs/info';
const execMathExpress = require('exec-mathexpress');
export default {
  name: 'web_monitor_workshop_mes_equipment_statistics',
  components: {
    gongyicanshu: gongyicanshu,
    shengchantongji: shengchantongji,
    gongkuangcanshu: gongkuangcanshu,
    baojingxinxi: baojingxinxi,
    jibenxinxi: jibenxinxi
  },
  props: {
    equipment: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tabsData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      current: 'shengchantongji',
      tabs: ['shengchantongji', 'gongyicanshu', 'gongkuangcanshu', 'baojingxinxi', 'jibenxinxi'],
      contentHeight: 0,
      tabHeight: 0
    };
  },

  created() {},
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {},
  computed: {
    gy() {
      return (str, deviceId, pointList) => {
        str = this.base64.decode(str);
        if (!str) {
          return null;
        }
        if (!this.equipment) {
          return null;
        }
        if (!this.tabsData.eqAuxiliaryPoints) {
          return null;
        }

        let reg1 = /\[[^\]]*\]/g;
        str.match(reg1) &&
          str.match(reg1).map(code => {
            let c = code.replace('[', '');
            c = c.replace(']', '');
            str = str.replace(code, this.$t(c));
          });
        let reg2 = /\{[^\}]*\}/g;
        str.match(reg2) &&
          str.match(reg2).map(code => {
            let c = code.replace('{', '');
            c = c.replace('}', '');

            if (!pointList[c]) {
              // this.utils.errorMessage('qitamobanqueshaodian' + ':' + c)
              console.log(this.$t('qitamobanqueshaodian') + ':' + c);
              str = str.replace(code, '-');
              return;
            }

            let raw = this.tabsData.eqAuxiliaryPoints[deviceId] && this.tabsData.eqAuxiliaryPoints[deviceId][c];
            let value = raw ? raw : "";

            if (pointList[c].dictTypeCode != null) {
              str = str.replace(code, this.$t(this.store.state.dictJsonAll[pointList[c].dictTypeCode][parseInt(value)]));
            } else {
              str = str.replace(code, value);
            }
          });
        return str;
      };
    }
  },
  methods: {
    handleClick(tab, event) {
      this.utils.event_hub.$emit('RESIZE');
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.tabHeight = this.contentHeight - 55;
      }, 500);
    }
  }
};
</script>
